module.exports = __webpack_public_path__ + "img/ceramics3.9febff0a.jpg";